import { Action, ResetPasswordFieldError, MessageDescriptor } from '../types';

export interface State {
  error: MessageDescriptor | string;
  fieldErrors: ResetPasswordFieldError;
  isLoading: boolean;
  isSent: boolean;
  redirectTo?: string;
}

export const defaultState: State = {
  error: '',
  fieldErrors: {},
  isLoading: false,
  isSent: false,
};

const resetPassword = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'RESET_PASSWORD_RESET':
      return {
        ...state,
        error: '',
        isLoading: false,
        isSent: false,
      };
    case 'RESET_PASSWORD_REQUEST_LINK':
      return {
        ...state,
        error: '',
        isLoading: true,
        isSent: false,
      };
    case 'RESET_PASSWORD_REQUEST_LINK_SUCCESS':
      return {
        ...state,
        error: '',
        isLoading: false,
        isSent: true,
      };
    case 'RESET_PASSWORD_REQUEST_LINK_REDIRECT':
      return {
        ...state,
        error: '',
        isLoading: true,
        isSent: false,
        redirectTo: action.redirectTo,
      };
    case 'RESET_PASSWORD_ERROR':
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isSent: false,
      };
    case 'RESET_PASSWORD_REQUEST_LINK_FAILED_WITH_FIELD_ERRORS':
      return {
        ...state,
        fieldErrors: action.fieldErrors,
        isLoading: false,
        isSent: false,
      };
    default:
      return state;
  }
};

export default resetPassword;
